/**
 * Cart threshold pump.
 *
 * Re-runs every registered progress-meter updater whenever the cart changes.
 * Updaters register themselves on window.__thresholdBannerUpdaters (see
 * snippets/cart-drawer.liquid); this file only detects cart mutations and hands
 * them a fresh /cart.js payload.
 *
 * This previously lived inline in sections/header.liquid behind
 * {% if customer.tags contains 'trade' %}, so retail visitors got no refresh at
 * all and any non-trade meter would render once and then go stale. It is loaded
 * unconditionally for every audience, and no-ops until an updater registers.
 */
(function () {
    window.__thresholdBannerUpdaters = window.__thresholdBannerUpdaters || {};

    async function refreshAllBanners() {
        let cart;
        try {
            const res = await fetch("/cart.js", { credentials: "same-origin" });
            if (!res.ok) throw new Error();
            cart = await res.json();
        } catch (e) {
            return;
        }

        Object.values(window.__thresholdBannerUpdaters).forEach((fn) => {
            if (typeof fn === "function") fn(cart);
        });
    }

    // Exposed so a surface can force a refresh after its own mutation.
    window.__refreshThresholdBanners = refreshAllBanners;

    const isCartMutation = (url) =>
        /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url || "");

    if (!window.__thresholdBannerPatched) {
        window.__thresholdBannerPatched = true;

        const originalFetch = window.fetch;
        window.fetch = function (input, init) {
            const url = typeof input === "string" ? input : input?.url;
            return originalFetch(input, init).then((res) => {
                if (isCartMutation(url) && res && res.ok) {
                    setTimeout(refreshAllBanners, 50);
                }
                return res;
            });
        };

        (function patchXHRPrototype() {
            if (window.__thresholdBannerXHRPatched) return;
            window.__thresholdBannerXHRPatched = true;

            const proto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
            if (!proto) return;

            const originalOpen = proto.open;
            const originalSend = proto.send;

            proto.open = function (method, url) {
                this.__thresholdBannerUrl = url;
                return originalOpen.apply(this, arguments);
            };

            proto.send = function () {
                try {
                    const url = this.__thresholdBannerUrl || "";
                    if (isCartMutation(url)) {
                        this.addEventListener("load", () => {
                            if (this.status >= 200 && this.status < 300) {
                                setTimeout(refreshAllBanners, 50);
                            }
                        });
                    }
                } catch (e) {}
                return originalSend.apply(this, arguments);
            };
        })();

        document.addEventListener("shopify:section:load", refreshAllBanners);
    }

    document.addEventListener("DOMContentLoaded", refreshAllBanners);
})();
